import BaseService from './base'
import axios from '@/plugins/axios'

export default class SecurityTransferRequestService extends BaseService {
  static resource() {
    return 'api/v1/external/securityTransferRequest'
  }

  static async post(accountCode, payload = {}) {
    const { data } = await axios.post(
      `${this.baseURL()}/${this.resource()}/${accountCode}`,
      payload
    )
    return data
  }
}
